<template>
	<Header
		title="Exports"
		:is-loading="loaderEnabled && listState.isLoading.value" />

	<Container>
		<TableFilters
			placeholder="Search exports..."
			:controls="controls"
			:filters="filters" />
	</Container>

	<Container class="exports-list">
		<ExportTable
			:list-state="listState"
			@page-change="loaderEnabled = true" />
	</Container>
</template>

<script setup lang="ts">
import Header from '@/components/Header.vue'
import Container from '@/components/Container.vue'
import ExportTable from '@/views/Export/components/Table.vue'
import { useExportListState } from '@/models/Export/States'
import TableFilters from '@/components/filters/TableFilters.vue'
import { FilterControls } from '@/helpers/filters/FilterControls'
import { Filters } from '@/helpers/filters/Filters'
import { ref, watch, watchEffect } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const listState = useExportListState()
listState.defaultParams = {
	with: ['build.app.repositoryConfigs', 'codeDeliveries'],
	orderBy: 'created_at',
	order: 'desc',
	per_page: 20,
}

const controls = new FilterControls([])
const route = useRoute()
const router = useRouter()
const filters = ref(Filters.fromQuery(route.query as any, controls))
const loaderEnabled = ref(true)

// sync search to URL and table
watch(
	() => route.query.s,
	async (val) => {
		loaderEnabled.value = true
		filters.value.search = typeof val === 'string' ? val : ''
		listState.defaultParams.search = filters.value.search
		await listState.getList()
	},
	{ immediate: true },
)

watch(
	() => filters.value.search,
	(val, prev) => {
		if (val === prev) return
		const q = { ...route.query }
		if (!val) delete (q as any).s
		else (q as any).s = val
		router.replace({ query: q })
	},
)

watchEffect(() => {
	if (listState.isLoaded.value && !listState.isLoading.value) loaderEnabled.value = false
})
</script>

<style lang="scss" scoped>
.exports-list {
	display: flex;
	justify-content: center;
	padding-top: 0;
}
</style>
